var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRemovePaymentMethod = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41667 5.75V14.0833C2.41667 15.9243 3.90905 17.4167 5.75 17.4167H10.75C12.5909 17.4167 14.0833 15.9243 14.0833 14.0833V5.75M9.91667 8.25V13.25M6.58333 8.25L6.58333 13.25M11.5833 3.25L10.4114 1.49217C10.1023 1.0285 9.58195 0.75 9.02469 0.75H7.47531C6.91805 0.75 6.39767 1.0285 6.08856 1.49217L4.91667 3.25M11.5833 3.25H4.91667M11.5833 3.25H15.75M4.91667 3.25H0.75",
    stroke: "#414651",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRemovePaymentMethod);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_remove_payment_method.7dfb851517e89c5b20c702e582cf6262.svg";